import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
Vue.prototype.$env_var = process.env
import * as moment from 'moment'
import fxViewMixins from './plugins/fxView/index.ts';
// websocket connection

import WebSocketService from '@/store/websocket.js'
Vue.prototype.$websocket = new WebSocketService();
Vue.prototype.$websocket.connect(); 
Vue.mixin(fxViewMixins);

Vue.prototype.$trackEvent = function(eventName, eventValue, eventUnit) {
  setTimeout(() => {
    try {
      if (typeof window.fz === 'function') {
        window.fz("event", {"name": eventName, "value": eventValue, "unit": eventUnit});
      } else {
        console.error("window.fz is not a function");
      }
    } catch (error) {
      console.error("An error occurred while tracking event:", error);
    }
  }, 5000);
};


import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import VueSimpleAccordion from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';

Vue.use(VueSimpleAccordion);
import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)


import Toasted from 'vue-toasted'
Vue.use(Toasted)
//==============vue-editor=======================
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)


//============clipboard========================
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//===============vue-cookies=================
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('30d')
Vue.$cookies.config('7d', '', '', true)

//===============vue-chat-scroll=================
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)
//===============multiselect=====================
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import 'vue-multiselect/dist/vue-multiselect.min.css';
//================feather icons==================
import VueFeather from 'vue-feather';
Vue.use(VueFeather);
//===============datatable=======================
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTable);
//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
//==============vee-validate=====================
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// // Extend with a custom rule that restricts special characters
VeeValidate.Validator.extend('no_special_characters', {
  getMessage: field => `${field} should not contain special characters.`,
  validate: value => !/[~!@#$?%^&*()]/.test(value)
});
//==============flash-message====================
// import Toast from "vue-toastification";
// import "vue-toastification/dist/index.css";
// Vue.use(Toast);
import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);
require('vue-flash-message/dist/vue-flash-message.min.css');
//==============moment===========================
Vue.use(require('vue-moment'))
//===============loader==========================
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);
//=========phone number with country code========
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

//==================vue-pdf==========================
import pdf from 'vue-pdf'
Vue.component('vue-pdf', pdf)

// ====================Vue otp input=================== 
import OtpInput from "@bachdgvn/vue-otp-input";

Vue.component("v-otp-input", OtpInput);



//===============language==========================
import i18n from '@/plugins/lang/i18n';
//========local components import globally=========
import change_entity from '@/components/fxView/shared/change_entity'
Vue.component('change-entity', change_entity)

// window._ = require('../static/fxView/js/chartiq.js');
// window.__ = require('../static/fxView/js/quoteFeedSimulator.js');

import filterComponent from '@/components/fxView/shared/filterComponent'
Vue.component('filter-component', filterComponent)
import paginationComponent from '@/components/fxView/shared/pagination'
Vue.component('pagination', paginationComponent)
import loaderComponent from '@/components/fxView/shared/loader_component'
Vue.component('loader-component', loaderComponent)
import messageComponent from '@/components/fxView/shared/message_component'
Vue.component('message-component', messageComponent)
import completeLoading from '@/components/fxView/shared/complete_loading'
Vue.component('complete-loading', completeLoading)
import no_trading_account from '@/components/fxView/shared/no_trading_account'
Vue.component('no-trading-account', no_trading_account)
import account_id from '@/components/fxView/shared/tradingAccounts/account_id'
Vue.component('account-id', account_id)

Vue.config.productionTip = false;
const params = new URLSearchParams(window.location.search);
if (params.get("auth")) {
  let data = { token: params.get("auth"), loggedIn: true, roles: '', email: '', profile: {} }
  localStorage.setItem('user', btoa(JSON.stringify(data)))
  /*router.replace('/dashboard')*/
  let src = document.location.origin + '/dashboard'
  location.replace(src);
}

// FOR MOBILE APPLICATION
// else if (params.get("token") ) {
// let data = params.get("token");
//   if(data){
//     if(data.includes("%3F")){
//       data =data.replace("%3F" , "?")
//     }
//     let token =  data.split('?')[0]
//     let device =  data.split('?')[1].replace('device=', '')
//     if(device && device !='' && device =='mobile'){
//       if(token && token !=''){
//         window.ReactNativeWebView.postMessage(JSON.stringify({ type: "1", message: "Payment completed" }));
//       }
// }
// }
//   // let data = { token: params.get("token"), loggedIn: true, roles: '', email: '', profile: {} }
//   // localStorage.setItem('user', btoa(JSON.stringify(data)))
//   // /*router.replace('/dashboard')*/
//   // let src = document.location.origin + '/dashboard'
//   // location.replace(src);
// } 


else if (params.get("accessToken")) {
  localStorage.removeItem("user");
}

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js